import axios from "axios";

/**
 * Uploads one image, video or audio file through the backend (`POST /upload`),
 * which pins it to IPFS. Returns its gateway URL, or undefined on failure.
 * Replaces the direct nft.storage and S3 uploads, which needed API keys in
 * this bundle.
 */
export default async function uploadFile(selectedFile) {
  if (!selectedFile) return undefined;
  try {
    const formData = new FormData();
    formData.append("file", selectedFile);
    const response = await axios.post(`${window.apiURL}/upload`, formData);
    return response.data.url;
  } catch (error) {
    console.error(error);
  }
}
